// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertSettingsActions } from "src/actions";

import { IProps, TabId } from "@blueprintjs/core";

import { ToggleButtons } from 'src/components';

import { SettingsSocialBanter, SettingsTabs } from '../components';

import { Redirect, Route, Switch } from "react-router-dom";

import "./styles.css";

interface IPawsSettingsProps extends IProps {
  accountType: string;
  routeProps: any;
  channels?: any;
  onChannelStatusChange: (channelType: string, history?: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onCloseRightPanel?(): void;
  onToggleRightPanel?(): void;
  onUpdateToolBar?(topBarProps: any): void;
}

interface IPawsSettingsState {
  selectedTabNum: TabId;
  tabs: Array<string>;
}

class IPawsSettings extends React.Component<IPawsSettingsProps, IPawsSettingsState> {
  constructor(props: IPawsSettingsProps) {
    super(props);
    this.onChannelStatusChange = this.onChannelStatusChange.bind(this);
    this.onChangeTab = this.onChangeTab.bind(this);
    this.updatedselectedTabNum = this.updatedselectedTabNum.bind(this);
    this.updateToolBar(this.props.accountType);
    this.state = {
      selectedTabNum: 0,
      tabs: ['account', 'settings'],
    }
  }

  public componentDidMount() {
    this.updatedselectedTabNum();
  }

  public componentWillReceiveProps(nextProps: IPawsSettingsProps) {
    if(nextProps.accountType !== this.props.accountType) {
      this.updateToolBar(nextProps.accountType);
    }
    if(nextProps.routeProps !== this.props.routeProps){
      this.updatedselectedTabNum();
    }
  }

  public render() {
    const { className, channels, accountType, routeProps } = this.props;
    const { selectedTabNum, tabs } = this.state;
    const ipaws = channels[accountType];
    return (
      <div className={classNames('social-settings-container', className)}>
          <Switch location={routeProps.history.location}>
            {ipaws.status ?
              <Redirect exact={true} from="/alerts-settings/ipaws" to="/alerts-settings/ipaws/account" />
              :
              <Redirect from='/alerts-settings/ipaws/*' to="/alerts-settings/ipaws" />
            }
            <Route
              exact={true}
              path={"/alerts-settings/ipaws/account"}
              render={() => (
                <React.Fragment>
                  <SettingsTabs
                    tabs={tabs}
                    tabsProps={{
                      id: 'social-settings-tabs',
                      onChange: this.onChangeTab,
                      selectedTabId: selectedTabNum
                    }}
                  />
                </React.Fragment>
                )}
              />
            <Route
              exact={true}
              path={"/alerts-settings/ipaws/settings"}
              render={() => (
                <React.Fragment>
                  <SettingsTabs 
                    tabs={tabs}
                    tabsProps={{
                      id: 'social-settings-tabs',
                      onChange: this.onChangeTab,
                      selectedTabId: selectedTabNum
                    }}
                  />
                </React.Fragment>
                )}
              />
              <Route
                exact={true}
                path={"/alerts-settings/ipaws"}
                render={() => (
                    <SettingsSocialBanter
                      imageName={'compose-alert--channels--' + [accountType] + '-active'}
                      title={accountType.charAt(0) + accountType.charAt(1).toUpperCase() + accountType.slice(2)}
                      active={ipaws.status}
                      subtitle={'Automatically post alerts to your ' + [accountType] + ' account'}
                      actionButtonText={'Install ' + accountType}
                      actionButtonTextActive='Installed'
                      actionButtonClick={this.onChannelStatusChange}
                    />
                )}
              />
          </Switch>
        
      </div>
    );
  }
  
  private updatedselectedTabNum() {
    const { routeProps, } = this.props;
    const { tabs } = this.state;
    const pathname = routeProps.history.location.pathname;
    const pathArr = pathname.split('/');
    const selectedTabNum = tabs.findIndex((tab:any) => tab === pathArr[pathArr.length - 1]);
    this.setState({ selectedTabNum });
  }

  private onChangeTab(newTabNum: TabId, prevTabNum: TabId, event: any) {
    const { routeProps } = this.props;
    const { tabs } = this.state;
    const tabId = tabs[newTabNum].toLowerCase();
    this.setState({ selectedTabNum: newTabNum })
    routeProps.history.push(`/alerts-settings/ipaws/${tabId}`);
  }

  private onChannelStatusChange(event: any) {
    const { accountType, routeProps } = this.props;
    const { history } = routeProps;
    this.props.onChannelStatusChange(accountType, history);
  }

  private updateToolBar(text: string) {
    const topBarProps = {
      leftElement: (
        <ToggleButtons
          label={text.charAt(0) + text.charAt(1).toUpperCase() + text.slice(2)}
          onToggle={this.props.onToggleRightPanel}
          onClose={this.props.onCloseRightPanel}
        />
      ),
    };
    if(this.props.onUpdateToolBar){
      this.props.onUpdateToolBar(topBarProps);
    }
  }
}

const mapStateToProps = (state: any) => {
  const {  alertSettings } = state;
  const { channels } = alertSettings;

  return {
    channels
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onChannelStatusChange: bindActionCreators(
      alertSettingsActions.onChangeChannelStatus,
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IPawsSettings);



// WEBPACK FOOTER //
// ./src/controllers/alert-settings/ipaws-settings/ipaws-settings.tsx